/*= ========================================================================================
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization  (TODO: Implement this functionality - pending approbation from carlos)
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
========================================================================================== */

export default [
        {
                url: '/',
                name: 'Inicio',
                slug: 'home',
                icon: 'HomeIcon',
        },
        {
                name: 'Finanzas',
                slug: 'finanzas',
                icon: 'TrendingUpIcon',
                submenu: [
                        {
                                name: 'Estado de Cuenta',
                                slug: 'account-statement',
                                iconName: 'invoice',
                                url: '/finances/statement',
                                iconFamily: 'local',
                        },
                ],
        },
];
